import classes from './Loading.module.css'

const Loading = (props) => {
  return (
    <div style={{marginTop:props.top}} className={classes.loadwrapp}>
      <div className={classes.load}>
        <div className={classes.line}></div>
        <div className={classes.line}></div>
        <div className={classes.line}></div>
      </div>
    </div>
  )
}

export default Loading